import { Check } from "lucide-react";

const POINTS = [
  "Davao City's leading and most trusted memorial park",
  "Lush, beautifully maintained gardens and lawn lots",
  "Peaceful, flood-free grounds your family can visit with pride",
  "A lasting family legacy and sound investment back home",
];

export default function About() {
  return (
    <section id="about" className="py-20 sm:py-28 px-4 sm:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative">
          <img
            src="/images/park-entrance.webp"
            alt="Entrance of Davao Memorial Park"
            data-testid="about-entrance-image"
            className="rounded-2xl w-full object-cover shadow-[0_12px_32px_rgba(12,35,64,0.12)]"
          />
          <img
            src="/images/park-roundabout.webp"
            alt="Serene grounds of Davao Memorial Park"
            data-testid="about-grounds-image"
            className="hidden sm:block absolute -bottom-10 -right-6 w-2/3 rounded-2xl border-8 border-[#FAFAF7] object-cover shadow-[0_12px_32px_rgba(12,35,64,0.18)]"
          />
        </div>

        <div className="lg:pl-6">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C59B27]">About DMPI</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#0C2340] mt-4 leading-tight">
            A sacred haven of peace and honor in the heart of Davao
          </h2>
          <p className="mt-6 text-base text-zinc-600 leading-relaxed">
            For decades, Davao Memorial Park has been the final resting place of
            choice for Davao families — a serene sanctuary of manicured lawns,
            towering trees, and quiet gardens where memories are honored with
            dignity.
          </p>
          <p className="mt-4 text-base text-zinc-600 leading-relaxed">
            For our overseas Filipino workers, securing a property at the Park
            means peace of mind: knowing that your loved ones — and one day, your
            own memory — will be cared for in a place of lasting beauty.
          </p>
          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="shrink-0 w-5 h-5 rounded-full bg-[#2E5A44]/10 flex items-center justify-center mt-0.5">
                  <Check className="w-3.5 h-3.5 text-[#2E5A44]" />
                </span>
                <span className="text-sm text-zinc-700">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
